export const textLabels = {
  body: {
    noMatch: 'Nenhum registro encontrado.',
    toolTip: 'Ordenar',
  },
  pagination: {
    next: 'Próxima Página',
    previous: 'Página anterior',
    rowsPerPage: 'Linhas por página:',
    displayRows: 'de',
  },
  toolbar: {
    search: 'Buscar',
    downloadCsv: 'Baixar CSV',
    print: 'Imprimir',
    viewColumns: 'Colunas Visíveis',
    filterTable: 'Filtrar tabela',
  },
  filter: {
    all: 'Todos',
    title: 'FILTROS',
    reset: 'REINICIAR',
  },
  viewColumns: {
    title: 'Mostrar Colunas',
    titleAria: 'Exibir/Mostrar colunas da tabela',
  },
  selectedRows: {
    text: 'Linha(s) selecionadas',
    delete: 'Apagar',
    deleteAria: 'Apagar linhas selecionadas',
  },
  compliance: 'Formulário de Análise',
}
